<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="32"></ucMenu>
          <div class="right_con">
            <div class="rc_main">
              <p class="fb">检测管理</p>
              <el-tabs v-model="activeTab" @tab-click="handleTabChange">
                <el-tab-pane label="关键词检测" name="keyword">
                  <keyword ref="keywordRef"></keyword>
                </el-tab-pane>
                <!-- <el-tab-pane label="图片关键词" name="imgKeyword">
                  <img-keyword ref="imgKeywordRef"></img-keyword>
                </el-tab-pane> -->
                <el-tab-pane label="图片检测" name="image">
                  <img-check ref="imgCheckRef"></img-check>
                </el-tab-pane>
                <el-tab-pane label="星人鉴图" name="alien">
<!--                  <alien-check ref="alienCheckRef"></alien-check>-->
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>
  </div>
</template>
<script >

import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import Keyword from "./keyword.vue";
import ImgKeyword from "./imgKeyword.vue";
import ImgCheck from "./imgCheck.vue";

export default ({
  name: 'ucenterCheck',
  data(){
    return {
      activeTab:'keyword'
    }
  },
  components: {Keyword, ucMenu, myFoot, myHead,ImgKeyword,ImgCheck},
  mounted() {
    this.handleTabChange({name:this.activeTab})
    // window.addEventListener('keydown', this.handleKeydown);

  },
  beforeDestroy() {
    // window.removeEventListener('keydown', this.handleKeydown);
  },
  methods:{
    handleTabChange(tab) {
      this.$nextTick(()=>{
        if(tab.name === 'keyword'){
          this.$refs.keywordRef.initData()
        }else if(tab.name === 'imgKeyword'){
          this.$refs.imgKeywordRef.refresh()
        }else if(tab.name === 'image'){
          this.$refs.imgCheckRef.initData()
        }else if(tab.name === 'alien'){
          // this.$refs.alienCheckRef.refresh()
          this.$router.push('/uc_alienCheck2')
        } else{
          this.$confirm("功能开发中，敬请期待！","提示",{
            showCancelButton:false
          })
        }
      })
    },
    handleKeydown(event) {
      if(this.activeTab=='alien'){
        if (event.key === 'q'||event.key === 'Q'||event.key === 'e'||event.key === 'E') {
          this.$nextTick(()=>{
            this.$refs.alienCheckRef.handlePreOrNext(event.key)
          })
        }
      }
    },
  }
})
</script>


<style scoped>
.wrap {
  overflow-x: hidden;
}

.center {
  display: flex;
  flex: 1;
}

.ucenter_main {
  min-height: 500px;
}

.rc_main {
  padding: 36px 40px 46px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box; /* 确保 padding 不会撑大容器宽度，防止溢出 */
}

.table-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.rc_table {
  width: 100%;
  margin-top: 10px;
  table-layout: fixed;
  min-width: 900px;
}

/* 表格单元格内容过长时，超出部分省略，避免撑破容器 */
.rc_table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
